/**
 * Text processing utilities for IELTS components
 */

/**
 * Clean HTML text and extract image URLs for AI processing
 * Strips HTML tags while preserving text content and explicitly listing image URLs
 * 
 * @param {string} htmlText - HTML string containing text and potentially images
 * @returns {string} - Clean text with image URLs appended
 */
export const cleanQuestionText = (htmlText) => {
  if (!htmlText) return '';
  
  // Create a temporary DOM element to parse HTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlText;
  
  // Extract image URLs
  const images = tempDiv.querySelectorAll('img');
  const imageUrls = Array.from(images).map(img => img.src || img.getAttribute('src')).filter(Boolean);
  
  // Get text content (strips HTML tags)
  let cleanText = tempDiv.textContent || tempDiv.innerText || '';
  
  // Add image URLs at the end if they exist
  if (imageUrls.length > 0) {
    cleanText += '\n\n[Images included in task: ' + imageUrls.join(', ') + ']';
  }
  
  return cleanText.trim();
};

/**
 * Count words in a text string
 * @param {string} text - Text to count words in
 * @returns {number} - Number of words
 */
export const countWords = (text) => {
  if (!text) return 0;
  return text
    .trim()
    .split(/\s+/)
    .filter((word) => word).length;
};

